export default "__VITE_ASSET__CbOitY_e__"